import React, { useContext } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { customFrequencyUtils } from 'app-components/flux/scheduled-transactions';
import Weekly from './Weekly';
import { FrequencyContext } from './state';

import { makeStyles } from 'tss-react/mui';

const { MIN_WEEKS, MAX_WEEKS } = customFrequencyUtils;

const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  freqDescription: {
    fontSize: 16,
    fontWeight: 500,
  },
  weekSelect: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiOutlinedInput-root': {
      margin: '0px 8px',
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 16px',
      borderRadius: '12px',
    },
    '& .MuiTextField-root': {
      width: 'auto',
    },
  },
  weekySection: {
    padding: '24px 0px 0px',
  },
}));

const EveryXWeeks = () => {
  const { state, dispatch } = useContext(FrequencyContext);
  const { classes } = useStyles();

  // @ts-expect-error FIXME TS7006
  const handleChange = (e) => {
    const interval = parseInt(e.target.value, 10);
    interval && dispatch({ type: 'UPDATE_EVERY_X_INTERVAL', payload: interval });
  };

  return (
    <Box id='every-x-weeks' className={classes.root}>
      <Box className={classes.weekSelect}>
        <Typography className={classes.freqDescription}>Every</Typography>
        <TextField
          type='number'
          inputProps={{ min: MIN_WEEKS, max: MAX_WEEKS }}
          value={state?.interval || 2}
          onChange={handleChange}
          variant='outlined'
        />
        <Typography className={classes.freqDescription}>weeks</Typography>
      </Box>
      <Box>
        <div className={classes.weekySection}>
          <Weekly />
        </div>
      </Box>
    </Box>
  );
};

export default EveryXWeeks;
